import React, { useEffect, useRef, useState } from 'react';
import { Button, Table, Card, Tabs, Tab } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
import Query from "@arcgis/core/rest/support/Query.js";
import * as query from "@arcgis/core/rest/query.js";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer.js";
import Graphic from "@arcgis/core/Graphic.js";
import Circle from "@arcgis/core/geometry/Circle.js";
import SimpleFillSymbol from "@arcgis/core/symbols/SimpleFillSymbol.js";
import SimpleLineSymbol from "@arcgis/core/symbols/SimpleLineSymbol.js";
import Color from "@arcgis/core/Color.js";
import SimpleMarkerSymbol from "@arcgis/core/symbols/SimpleMarkerSymbol.js";
import Point from "@arcgis/core/geometry/Point.js";
import config from './Config.json';
import './buffer.css';
import Draggable from 'react-draggable';
import excel from './images/xls.png'
import * as XLSX from 'xlsx';

var array = [];
var list = [];
var buffergeomGraphic;
var count = 0;
const BufferTool = (mapView) => {

  const [activeTab, setActiveTab] = useState("buffer");
  const [Selvalue, setSelvaue] = useState('0');
  const [distance, setDistance] = useState();
  const [data, setData] = useState(config)
  const [isTableCardOpen, setIsTableCardOpen] = useState(false);
  const [fields, setFields] = useState([]);
  const [resdata, setResdata] = useState([]);

  const [atmfields, setAtmFields] = useState([]);
  const [atmdata, setAtmResdata] = useState([]);

  const [mithrafields, setithraFields] = useState([]);
  const [mithradata, setMithraResdata] = useState([]);

  const [ippbfields, setippbFields] = useState([]);
  const [ippbdata, setippbResdata] = useState([]);
  const [isTableippbOpen, setIsTableippbOpen] = useState(false)


  const [isTablebranchOpen1, setIsTablebranchOpen1] = useState(false)
  const [isTablemithtaOpen, setIsTablemithraOpen] = useState(false)
  const [isTableAtmOpen, setIsTableAtmhOpen] = useState(false)
  const [isMinimized, setIsMinimized] = useState(false);
  const [tabTitles, setTabTitles] = useState({
    bank: "Bank Branch",
    atm: "ATM",
    mithra: "Bank Mitra",
    ippb: "IPPB"
  });
  const [key, setKey] = useState('bank');

  useEffect(() => {
    buffergeomGraphic = new GraphicsLayer();
    buffergeomGraphic.listMode = "hide";

  }, [])

  const Execute = () => {

    if (Selvalue == 0) {
      alert('Please Select Layers');
      return false;
    }
    else if (document.getElementById("txtDistance").value == 0 || document.getElementById("txtDistance").value == "") {
      alert("please Enter Distance")
      return false;
    }


    document.getElementById('buffertip').style.display = "inline";
    var bufferEvent = mapView.view.on("click", (event) => {
      bufferEvent.remove();
      document.getElementById('buffertip').style.display = "none";
      setIsTablebranchOpen1(false);
      setIsTableAtmhOpen(false);
      setIsTablemithraOpen(false);
      setIsTableippbOpen(false);

      setAtmResdata([]);
      setResdata([]);
      setMithraResdata([]);
      setippbResdata([]);
      setKey('bank');


      //   var circleSymb = new SimpleFillSymbol(
      //     SimpleFillSymbol.STYLE_SOLID,
      //     new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID,
      //         new Color([0, 255, 255]), 4), new Color([229, 255, 255, 0.4])
      // );

      //   var buffergeom = new Circle({
      //     center: event.mapPoint,
      //     geodesic: true,
      //     radius: parseInt(document.getElementById("txtDistance")),
      //     radiusUnit: "Kilometers"
      // });


      const circleSymbol = new SimpleFillSymbol({
        color: [0, 0, 255, 0.20], // Blue with transparency
        outline: {
          color: [0, 150, 255],
          width: 2
        }
      });

      
      // Get the selected unit from dropdown
const unit = document.getElementById("ddBufferUnit").value;
const distance = parseInt(document.getElementById("txtDistance").value);

// Determine radius and unit
const radiusUnit = unit === "1" ? "kilometers" : "meters";
const radius = unit === "1" ? distance : distance;

      var circleGeometry = new Circle({
        center: event.mapPoint,
        geodesic: true,
        numberOfPoints: 100,
        radius: radius,        // Uses the entered value directly
        radiusUnit: radiusUnit // "kilometers" or "meters" based on selection
      })
      mapView.view.goTo({
        target: circleGeometry,
        zoom: 11 // Optional: Adjust the zoom level
      });

      mapView.view.graphics.removeAll();
      buffergeomGraphic = new Graphic(
        {
          geometry: circleGeometry,
          symbol: circleSymbol
        });
      mapView.view.graphics.add(buffergeomGraphic);

      if (Selvalue === "5,6,7,66") { // ALL option
    // Execute queries for all layers
    var dtparams = new Query({
      outFields: ["*"],
      where: "1=1",
      geometry: circleGeometry,
    });

    query
      .executeQueryJSON(data.layerForQuery.DataLayer[0].Url + "/" + data.layerForQuery.DataLayer[0].infotemplates[0].id + "?token=", dtparams)
      .then(response => Results(response, "Bank"))
      .catch();

    query
      .executeQueryJSON(data.layerForQuery.DataLayer[0].Url + "/" + data.layerForQuery.DataLayer[0].infotemplates[1].id + "?token=", dtparams)
      .then(response => Results(response, "ATM"))
      .catch();

    query
      .executeQueryJSON(data.layerForQuery.DataLayer[0].Url + "/" + data.layerForQuery.DataLayer[0].infotemplates[2].id + "?token=", dtparams)
      .then(response => Results(response, "Mithra"))
      .catch();

    query
      .executeQueryJSON(data.layerForQuery.DataLayer[0].Url + "/" + data.layerForQuery.DataLayer[0].infotemplates[9].id + "?token=", dtparams)
      .then(response => Results(response, "IPPB"))
      .catch();

  } else {

        var dtparams = new Query({
          outFields: ["*"],
          where: "1=1",
          geometry: circleGeometry,
        });

        query
          .executeQueryJSON(data.layerForQuery.DataLayer[0].Url + "/" + Selvalue + "?token=", dtparams)
          .then(response => Resultsone(response))
          .catch();

      }



      function Results(response, param) {

        list = [];
        array = [];
        setIsTableCardOpen(true);
        console.log(response);


        let larArray = response.features;
        //showthepointonmap(values[j], "esriGeometryPoint");
        for (var m = 0; m < larArray.length; m++) {
          array.push(larArray[m]);
        }
        array.forEach(function (item) {
          list.push(item.attributes);
        });
        console.log(list);


        if (param === "Bank") {
          if (list.length > 0) {
            setFields(data.layerForQuery.DataLayer[0].infotemplates[0].fields);
            setResdata(list);
            setIsTablebranchOpen1(true);
          }
        }
        else if (param === "ATM") {
          if (list.length > 0) {
            setAtmFields(data.layerForQuery.DataLayer[0].infotemplates[1].fields);
            setAtmResdata(list);
            setIsTableAtmhOpen(true)
          }

        }
        else if (param == "Mithra") {
          if (list.length > 0) {
            setithraFields(data.layerForQuery.DataLayer[0].infotemplates[2].fields);
            setMithraResdata(list);
            setIsTablemithraOpen(true);
          }

        } else if (param === "IPPB") {
          if (list.length > 0) {
            setippbFields(data.layerForQuery.DataLayer[0].infotemplates[9].fields);
            setippbResdata(list);
            setIsTableippbOpen(true);

          }
        }


      }

      function Resultsone(response) {

        count++;
        list = [];
        array = [];

        console.log(response);


        let larArray = response.features;
        //showthepointonmap(values[j], "esriGeometryPoint");
        for (var m = 0; m < larArray.length; m++) {
          array.push(larArray[m]);
        }
        array.forEach(function (item) {
          list.push(item.attributes);
        });
        console.log(list);


        if (Selvalue === data.layerForQuery.DataLayer[0].infotemplates[0].id) {

          setFields(data.layerForQuery.DataLayer[0].infotemplates[0].fields);
          setResdata(list);
          if (list.length > 0) {
            setIsTablebranchOpen1(true);
          }
          else {
            alert("Bank Branchs Not Found");
            return false;
          }
        }
        else if (Selvalue === data.layerForQuery.DataLayer[0].infotemplates[1].id) {
          setAtmFields(data.layerForQuery.DataLayer[0].infotemplates[1].fields);
          setAtmResdata(list);
          if (list.length > 0) {
            setIsTableAtmhOpen(true);
          }
          else {
            alert("ATMs Not Found");
            return false;
          }

        }
        else if (Selvalue == data.layerForQuery.DataLayer[0].infotemplates[2].id) {
          setithraFields(data.layerForQuery.DataLayer[0].infotemplates[2].fields);
          setMithraResdata(list);
          if (list.length > 0) {
            setIsTablemithraOpen(true);
          }
          else {
            alert("Bank Mithra Not Found");
            return false;
          }

        }
        else if (Selvalue === data.layerForQuery.DataLayer[0].infotemplates[9].id) {
          setippbFields(data.layerForQuery.DataLayer[0].infotemplates[9].fields);
          setippbResdata(list);
          if (list.length > 0) {
            setIsTableippbOpen(true);
            setKey('ippb');
          }
          else {
            alert("IPPB Not Found");
            return false;
          }

        }


        setIsTableCardOpen(true);


      }


    })
  }


  const SelLayers = (evt) => {
    setSelvaue(evt.target.value);
  }
  const handleCloseTableCard = () => {
    setIsTableCardOpen(false); // Close the table card
    setIsTablebranchOpen1(false);
    setIsTableAtmhOpen(false);
    setIsTablemithraOpen(false);
    setIsTableippbOpen(false);

    // mapView.view.graphics.removeAll();
  };

  const RowHandler = (latitude, longitude) => {


    //zoomGraphicLayer.graphics.removeAll();
    mapView.view.map.findLayerById("Zoompoint").graphics.removeAll();
    const point = new Point({
      longitude: longitude,
      latitude: latitude
    });

    mapView.view.goTo({
      target: point,
      zoom: 15 // Zoom level you desire
    });
    var zoomsymbol = new SimpleMarkerSymbol({
      // orange
      outline: {
        color: [255, 0, 0], // white
        width: 1
      }
    });

    mapView.view.map.findLayerById("Zoompoint").add(new Graphic(
      {
        geometry: point,
        symbol: zoomsymbol
      }
    ));
  }

  const reset = () => {
    setIsTableCardOpen(false); // Close the table card
    setIsTablebranchOpen1(false);
    setIsTableAtmhOpen(false);
    setIsTablemithraOpen(false);
    setIsTableippbOpen(false);
    document.getElementById('ddBufferTargetLyr').selectedIndex = 0;
    document.getElementById('txtDistance').value = '';
    document.getElementById('buffertip').style.display = "none";
    mapView.view.graphics.removeAll();
    mapView.view.map.findLayerById("Zoompoint").graphics.removeAll();
  }
  const tabselect = (evt) => {
    if (evt !== key) {
      if (evt === "bank") {
        setKey(evt);
      }
      else if (evt === "atm") {
        setKey(evt);

      }
      else if (evt === "mithra") {
        setKey(evt);

      }
      else if (evt === "ippb") {
        setKey(evt);

      }

    }
  }


   const handleExportToExcel = () => {
  // Get data based on active tab
  let exportData = [];
  let fields = [];
  let fileName = '';

  switch (key) {
    case 'bank':
      if (resdata.length === 0) {
        alert('No data available to export for Bank Branch');
        return;
      }
      exportData = resdata;
      fields = data.layerForQuery.DataLayer[0].infotemplates[0].fields;
      fileName = 'Bank_Branch_Data';
      break;

    case 'atm':
      if (atmdata.length === 0) {
        alert('No data available to export for ATM');
        return;
      }
      exportData = atmdata;
      fields = data.layerForQuery.DataLayer[0].infotemplates[1].fields;
      fileName = 'ATM_Data';
      break;

    case 'mithra':
      if (mithradata.length === 0) {
        alert('No data available to export for Bank Mitra');
        return;
      }
      exportData = mithradata;
      fields = data.layerForQuery.DataLayer[0].infotemplates[2].fields;
      fileName = 'Bank_Mitra_Data';
      break;

    case 'ippb':
      if (ippbdata.length === 0) {
        alert('No data available to export for IPPB');
        return;
      }
      exportData = ippbdata;
      fields = data.layerForQuery.DataLayer[0].infotemplates[9].fields;
      fileName = 'IPPB_Data';
      break;

    default:
      alert('No active tab selected');
      return;
  }

  // Prepare CSV content
  const headers = fields.map(field => field.alias).join(',');
  const csvRows = exportData.map(row => {
    return fields.map(field => {
      const value = row[field.name] || '-';
      // Handle values that might contain commas by wrapping in quotes
      return `"${String(value).replace(/"/g, '""')}"`;
    }).join(',');
  });

  const csvContent = [headers, ...csvRows].join('\n');

  // Create and download the file
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', `${fileName}_${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  // Clean up URL object
  setTimeout(() => URL.revokeObjectURL(url), 100);
};

  return (
    <div>


      <select id="ddBufferTargetLyr" title="Target Layer" className='form-select' style={{ width: "100%" }} onChange={SelLayers}>
        <option value="0">Select Target Layer</option>
        <option value="5,6,7,66">ALL</option>
        <option value={data.layerForQuery.DataLayer[0].infotemplates[0].id}>BANKBRANCH</option>
        <option value={data.layerForQuery.DataLayer[0].infotemplates[1].id}>ATM</option>
        <option value={data.layerForQuery.DataLayer[0].infotemplates[2].id}>BANKMITRA</option>
        <option value={data.layerForQuery.DataLayer[0].infotemplates[9].id}>IPPB</option>
      </select>
      <br></br>
      <input placeholder="Enter Distance" className="form-select" title="Buffer Distance" id="txtDistance" maxlength="5" style={{ width: "100%" }} />
      <br></br>
      <select id="ddBufferUnit" className="form-select" title="Buffer Unit" style={{ width: "100%", marginBottom: "10px" }}>
        <option value="1">Kilometers</option>
        <option value="2">Meters</option>

      </select>
      <div>
        {/* <input id="btnBufferQuery" type="button" value="Execute" onClick={Execute} style={{"margin-right": "10px","background-color":"#0c3793","color":"white"}}/>
                            <input id="btnBufferReset" type="button" value="Reset" onClick={reset} style={{"background-color":"#0c3793", "color":"white"}} /> */}
        <input id="btnBufferQuery" onClick={Execute} type="button" value="Execute" class="btn btn-primary me-2 shadow" />
        <input id="btnBufferReset" onClick={reset} type="button" value="Reset" class="btn btn-danger shadow" />

      </div>
      <span id='buffertip' style={{ "display": "none", "font-size": "12px", "color": "red" }}>Click on the map after pressing execute</span>
      <div id="bufferResultsDDdiv" style={{ "display": "none" }}>
        <select id="ddBufferResult" title="Buffer Results">
          <option value="">Select Results</option>
        </select>
      </div>

      {/* Table Card */}
      {isTableCardOpen && (
        <Draggable
          disabled={window.innerWidth <= 768}
          handle=".drag-handle"
        >
          <div
            style={{
              position: 'fixed',
              bottom: '5px',
              left: '5%',
              transform: 'translateX(-100%)',
              zIndex: 1060,
              width: "30%",
              zoom: "0.8" 
            }}className='mob_bot_card'
          >
            <Card
              className={`card-container card_drag_mob ${isMinimized ? 'card-minimized' : 'card-maximized'}`}
              style={{
                borderRadius: '10px'
              }}
            >
              <Card.Header className="d-flex justify-content-between drag-handle" style={{ backgroundColor: "#dcf5f2", height: "45px" }}>
                <h5 style={{ fontSize: "large", fontWeight: "700" }}>Result Table</h5>
                <div className="d-flex">
                  <Button variant="link" onClick={() => setIsMinimized(!isMinimized)}>
                    <i className="material-icons" style={{ fontSize: '24px' }}>
                      {isMinimized ? 'fullscreen' : 'minimize'}
                    </i>
                  </Button>
                  <Button variant="link" onClick={handleCloseTableCard}>
                    <i className="material-icons" style={{ fontSize: '24px' }}>close</i>
                  </Button>
                </div>
              </Card.Header>

              {!isMinimized && (
                <Card.Body>
                  <img
                        src={excel}  // Replace with your actual image path
                        alt="Export to Excel"
                        onClick={() => handleExportToExcel()}
                        style={{
                          cursor: 'pointer',
                          width: '32px',
                          height: '32px',
                          marginLeft: '10px',
                          transition: 'transform 0.2s',
                          justifySelf: "self-end",
                          float: "inline-end"
                        }}
                        onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                        onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                        title="Export to Excel"
                      />
                  <Tabs
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={tabselect}
                    className="mb-3"
                  >

                    {isTablebranchOpen1 && resdata.length > 0 && (
                      <Tab eventKey="bank" title={
                                              <>
                                                {tabTitles.bank}
                                                <span style={{ marginLeft: "5px" }}>({resdata.length})</span>
                                              </>
                                            }>
                        <div className="table-responsive " style={{ maxHeight: '13rem', overflowY: 'auto' }}>

                          <Table className='table table-bordered tableborderedth tablefontsize table-striped table-hover dashtbl' >
                            <thead className="table-header" style={{ position: 'sticky', top: "-1px", zIndex: 2, backgroundColor: '#fff' }}>
                              <tr className='mark_nor'>
                                {fields.map((field) => (
                                  <th key={field.name}>{field.alias}</th>
                                ))}
                                {/* Add more columns as needed */}
                              </tr>
                            </thead>
                            <tbody>
                              {resdata.map((row, rowIndex) => (
                                <tr key={`${row.latitude}-${row.longitude}`} onClick={() => RowHandler(row.latitude, row.longitude)}>
                                  {fields.map((field) => (
                                    <td key={field.name}>{row[field.name] || "-"}</td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      </Tab>
                    )}


                    {isTableAtmOpen && atmdata.length > 0 && (
                      <Tab eventKey="atm" title={
                                               <>
                                              {tabTitles.atm}
                                              <span style={{ marginLeft: "5px" }}>({atmdata.length})</span>
                                              </>
                                              }>
                        <div className="table-responsive " style={{ maxHeight: '13rem', overflowY: 'auto' }}>

                          <Table className='table table-bordered tableborderedth tablefontsize table-striped table-hover dashtbl' >
                            <thead className="table-header" style={{ position: 'sticky', top: "-1px", zIndex: 2, backgroundColor: '#fff' }}>
                              <tr className='mark_nor'>
                                {atmfields.map((field) => (
                                  <th key={field.name}>{field.alias}</th>
                                ))}
                                {/* Add more columns as needed */}
                              </tr>
                            </thead>
                            <tbody>
                              {atmdata.map((row, rowIndex) => (
                                <tr key={`${row.latitude}-${row.longitude}`} onClick={() => RowHandler(row.latitude, row.longitude)}>
                                  {atmfields.map((field) => (
                                    <td key={field.name}>{row[field.name] || "-"}</td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      </Tab>
                    )}


                    {isTablemithtaOpen && mithradata.length > 0 && (
                      <Tab eventKey="mithra" title={
                                              <>
                                              {tabTitles.mithra}
                                              <span style={{ marginLeft: "5px" }}>({mithradata.length})</span>
                                              </>
                                              }>
                        <div className="table-responsive " style={{ maxHeight: '13rem', overflowY: 'auto' }}>

                          <Table className='table table-bordered tableborderedth tablefontsize table-striped table-hover dashtbl' >
                            <thead className="table-header" style={{ position: 'sticky', top: "-1px", zIndex: 2, backgroundColor: '#fff' }}>
                              <tr className='mark_nor'>
                                {mithrafields.map((field) => (
                                  <th key={field.name}>{field.alias}</th>
                                ))}
                                {/* Add more columns as needed */}
                              </tr>
                            </thead>
                            <tbody>
                              {mithradata.map((row, rowIndex) => (
                                <tr key={`${row.latitude}-${row.longitude}`} onClick={() => RowHandler(row.latitude, row.longitude)}>
                                  {mithrafields.map((field) => (
                                    <td key={field.name}>{row[field.name] || "-"}</td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      </Tab>
                    )}

                    {isTableippbOpen && ippbdata.length > 0 && (
                      <Tab eventKey="ippb" title={
                                              <>
                                              {tabTitles.ippb}
                                              <span style={{ marginLeft: "5px" }}>({ippbdata.length})</span>
                                           </>   
                                          }>
                        <div className="table-responsive" style={{ maxHeight: '13rem', overflowY: 'auto' }}>
                          <Table className='table table-bordered tableborderedth tablefontsize table-striped table-hover dashtbl'>
                            <thead className="table-header" style={{ position: 'sticky', top: "-1px", zIndex: 2, backgroundColor: '#fff' }}>
                              <tr className='mark_nor'>
                                {ippbfields.map((field) => (
                                  <th key={field.name}>{field.alias}</th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {ippbdata.map((row) => (
                                <tr key={`${row.latitude}-${row.longitude}`} onClick={() => RowHandler(row.latitude, row.longitude)}>
                                  {ippbfields.map((field) => (
                                    <td key={field.name}>{row[field.name] || "-"}</td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      </Tab>
                    )}

                  </Tabs>
                </Card.Body>
              )}
            </Card>
          </div>
        </Draggable>
      )}



    </div>
  )
}

export default BufferTool;